module.exports = __webpack_public_path__ + "static/img/career-positioning.80412c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/specialist/career-positioning.png
// module id = 65mC
// module chunks = 1